/**
The representation of a locale, pairing the locale's display `name` with a `code` recognized by the browser/Mozilla library and our localization logic.

Available locales are found in `BenchlingLocale`
*/
export interface LanguageTag {
  code: string;
  name: string;
}

// Datetime formats we support that aren't in langmap
// Keep in sync with benchling/lib/core/locales.py:BENCHLING_LOCALES
export const BENCHLING_LOCALE_TAGS = {
  'bnch-12hr': 'International (12 hour)',
  'bnch-24hr': 'International (24 hour)',
};

// The default date to use when displaying the language picker. This date has been selected to make it obvious
//  how the selected date format handles months vs days.
export const DATE_TO_DISPLAY_WITH_LANGUAGE_TAG = '2023-01-25T13:35:00';

// The default date to use when displaying the language picker.
export const DEFAULT_DISPLAY_NUMBER = '1234567.89';

export const DEFAULT_LANGUAGE_TAG: LanguageTag = {
  code: 'en-US',
  name: 'English (US)',
};
